// ─── Bots adverses ────────────────────────────────────────────────────────────
// Pool de bots avec un ELO. Le matchmaking choisit le bot le plus proche de
// l'ELO du joueur (± une marge aléatoire). Ajuste librement noms / ELO ici.

export interface Bot {
  id: string;
  name: string;
  avatar: string;
  elo: number;
}

// Échelle ELO départ 100 (divisions tous les 100 pts, Diamond 600).
export const BOTS: Bot[] = [
  { id: "b1", name: "Rookie Rob", avatar: "🐣", elo: 0 },
  { id: "b2", name: "Zeno", avatar: "🕵️", elo: 50 },
  { id: "b3", name: "Vex", avatar: "🧟", elo: 150 },
  { id: "b4", name: "Nox", avatar: "👽", elo: 250 },
  { id: "b5", name: "Rok", avatar: "🤖", elo: 350 },
  { id: "b6", name: "Kaiser", avatar: "👹", elo: 500 },
  { id: "b7", name: "Titan", avatar: "🐲", elo: 700 },
];

/** Choisit un bot proche de l'ELO du joueur (fenêtre ± MATCH_WINDOW). */
export function pickBot(playerElo: number, rng: () => number = Math.random): Bot {
  const MATCH_WINDOW = 150;
  const eligible = BOTS.filter((b) => Math.abs(b.elo - playerElo) <= MATCH_WINDOW);
  const pool = eligible.length > 0 ? eligible : BOTS;
  return pool[Math.floor(rng() * pool.length)];
}
